export const ROUTES = {
  HOME: window.location.hostname == 'playground.z.wiki' ? '/img-cloud/index.html' : '/',
  MONITOR: '/monitor',
  ABOUT: '/about',
  DEMO: '/demo',
} as const;

export const ROUTE_NAMES = {
  [ROUTES.HOME]: '首页',
  [ROUTES.MONITOR]: '监控',
  [ROUTES.ABOUT]: '关于',
  [ROUTES.DEMO]: '演示',
} as const; 